import Vue from "vue";

Vue.component("wto-chart", {
	props: ["loading", "hasData", "chartOptions", "footer", "loadingText"],
	template: `
	    <div>
	        <div v-if="loading">
				<loading loading-text="loadingText"></loading>
	        </div>
	        <div v-else>
	            <div v-if="hasData">
	                <div class="bg-blue-lighter" id="chart">
	                    <highcharts :options="chartOptions" style="width: inherit"></highcharts>
	                </div>
	                <p class="text-muted mt-3" v-html="footer"></p>
	            </div>

	            <div v-else class="bg-blue-lighter d-flex justify-content-center align-items-center" style="height: 400px;">
	                No available data for {{ chartOptions.title.text }} chart
	            </div>
	        </div>
	    </div>
	`
});